const normalizeCategories = (categories) => {
    if (!Array.isArray(categories)) {
        return [];
    }

    return categories.map((category) => {
        const id = String(category.id);
        const name = category.name || category.title || '';
        const parentId = category.parent_id ? String(category.parent_id) : null;

        return { id, name, parentId };
    });
};

export default normalizeCategories;
